import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import About from "../components/About";
import CalendlyModal from "../components/CalendlyModal";
import Nav from "../components/Nav";

export default function AboutPage() {
    const [calOpen, setCalOpen] = useState(false);
    const onBook = () => setCalOpen(true);
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="min-h-screen bg-powder text-ink" data-testid="about-page">
            <div className="grain-overlay" />
            <Nav onBook={onBook} variant="solid" />

            <div className="pt-20 md:pt-24">
                <About />
            </div>

            {/* CTA */}
            <section className="bg-powder pb-24 -mt-8">
                <div className="max-w-[1600px] mx-auto px-5 md:px-12">
                    <div className="bg-ink text-white p-8 md:p-12 text-center">
                        <p className="font-serif text-3xl md:text-4xl mb-6">Vuoi allenarti con me?</p>
                        <button onClick={onBook} data-testid="about-book-btn" className="btn-fuchsia">
                            Prenota una consulenza gratuita, in presenza o online <ArrowUpRight size={18} />
                        </button>
                    </div>
                </div>
            </section>

            <CalendlyModal open={calOpen} onOpenChange={setCalOpen} />
        </div>
    );
}
